<mat-card class="layer-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group class="layer-header">
      <mat-card-title>
        <mat-checkbox
          [checked]="layer.isSelected"
          (change)="showRemoveLayer()"
          [disabled]="isLayerLoading()"
          >{{ layer.name }}
        </mat-checkbox>
      </mat-card-title>
      @if (isLayerLoading()) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </mat-card-title-group>
  </mat-card-header>

  @if (layer.isSelected) {
    <mat-card-content class="mat-card-content">
      <div class="mat-card-info">
        <!-- This div is for future layer description -->
        <p></p>

        <div class="mat-card-buttons">
          <a [href]="layer.repoUrl" target="_blank">
            <button matIconButton aria-label="Repository url" matTooltip="Repository url">
              <mat-icon>info</mat-icon>
            </button>
          </a>

          @if (layer.downloadUrl) {
            <a [href]="layer.downloadUrl" download>
              <button matIconButton aria-label="Download layer" matTooltip="Download layer">
                <mat-icon>download</mat-icon>
              </button>
            </a>
          }

          @if (isLoading$()) {
            <button matIconButton><mat-spinner diameter="24"></mat-spinner></button>
          } @else {
            <span
              [matTooltip]="
                allowDownload$()
                  ? 'Download selection'
                  : 'No zone selected or selection too large to download'
              "
            >
              <button
                matIconButton
                aria-label="Download selection"
                [disabled]="!allowDownload$()"
                (click)="exportLayerSelection()"
              >
                <mat-icon [class.blue-icon]="allowDownload$()">download</mat-icon>
              </button>
            </span>
          }
        </div>
      </div>

      <div class="mat-card-symbology">
        @if (layer.attributionImage) {
          <img
            class="attribution-image"
            [src]="layer.attributionImage"
            alt="Attribution"
            onerror="this.style.display = 'none'"
          />
        }
        <img
          src="{{ imageUrl }}{{ layer.layer_type }}"
          onerror="this.style.visibility = 'hidden'"
        />
      </div>
    </mat-card-content>
  }
</mat-card>
